function normalizeCampaignBestLabel(value) {
  return String(value || "")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();
}

function isCampaignBestTouchDevice() {
  return (
    "ontouchstart" in window ||
    (navigator.maxTouchPoints && navigator.maxTouchPoints > 0)
  );
}

function getCampaignBestMinSlidesForLoop(options) {
  var slidesPerView = options.slidesPerView;
  var slidesPerGroup = options.slidesPerGroup || 1;
  var loopAdditionalSlides = options.loopAdditionalSlides || 0;
  var centeredSlides = options.centeredSlides === true;
  var loopSlidesPerView = Math.ceil(slidesPerView);

  if (centeredSlides && loopSlidesPerView % 2 === 0) {
    loopSlidesPerView += 1;
  }

  var loopedGroup = centeredSlides
    ? Math.max(slidesPerGroup, Math.ceil(loopSlidesPerView / 2))
    : slidesPerGroup;

  if (loopedGroup % slidesPerGroup !== 0) {
    loopedGroup += slidesPerGroup - (loopedGroup % slidesPerGroup);
  }

  loopedGroup += loopAdditionalSlides;

  return loopSlidesPerView + loopedGroup;
}

function resolveCampaignBestSwiperModes(options) {
  var slideCount = options.slideCount;
  var slidesPerViewMax = options.slidesPerViewMax;
  var loopEnabled = options.loopEnabled;
  var desktopDragEnabled = options.desktopDragEnabled;
  var autoplayEnabled = options.autoplayEnabled;
  var freeModeEnabled = options.freeModeEnabled !== false;
  var isTouchDevice = options.isTouchDevice;
  var isFinePointer = options.isFinePointer;
  var minSlidesForLoop = getCampaignBestMinSlidesForLoop({
    slidesPerView: slidesPerViewMax,
    slidesPerGroup: options.slidesPerGroup || 1,
    loopAdditionalSlides: options.loopAdditionalSlides || 0,
    centeredSlides: options.centeredSlides === true,
  });
  var hasOverflowSlides = slideCount > slidesPerViewMax;
  var useLoop =
    loopEnabled && hasOverflowSlides && slideCount >= minSlidesForLoop;
  var useRewind = !useLoop && autoplayEnabled && hasOverflowSlides;
  var useCustomDesktopDrag =
    desktopDragEnabled && isFinePointer && !isTouchDevice && !useLoop;
  var enableSwiperTouch =
    isTouchDevice || (desktopDragEnabled && !useCustomDesktopDrag);
  var useFreeMode = freeModeEnabled && !useLoop && !useRewind;

  return {
    useLoop: useLoop,
    useRewind: useRewind,
    useCustomDesktopDrag: useCustomDesktopDrag,
    enableSwiperTouch: enableSwiperTouch,
    useFreeMode: useFreeMode,
  };
}

function parseCampaignBestSettingNumber(value, fallback) {
  var parsed = parseFloat(value);
  return Number.isFinite(parsed) ? parsed : fallback;
}

function buildCampaignBestFreeModeConfig(options) {
  if (!options.useFreeMode) {
    return { enabled: false };
  }

  var momentumRatio = parseCampaignBestSettingNumber(
    options.momentumRatio,
    0.85,
  );

  return {
    enabled: true,
    sticky: options.sticky !== false,
    momentum: true,
    momentumRatio: momentumRatio,
    momentumVelocityRatio: momentumRatio,
    momentumBounce: options.momentumBounce !== false,
  };
}

function buildCampaignBestAutoplayConfig(options) {
  return {
    delay: options.delay,
    disableOnInteraction: false,
    pauseOnMouseEnter: options.pauseOnHover !== false,
    waitForTransition: true,
    stopOnLastSlide: false,
  };
}

function buildCampaignBestSwiperInteractionConfig(options) {
  var swipeThreshold = parseCampaignBestSettingNumber(
    options.swipeThreshold,
    12,
  );
  var transitionSpeed = parseCampaignBestSettingNumber(
    options.transitionSpeed,
    500,
  );

  return {
    speed: transitionSpeed,
    threshold: options.enableSwiperTouch
      ? swipeThreshold
      : Math.max(swipeThreshold - 2, 5),
    grabCursor:
      options.grabCursorEnabled !== false && options.enableSwiperTouch,
    desktopDragThreshold: parseCampaignBestSettingNumber(
      options.desktopDragThreshold,
      5,
    ),
  };
}

function readCampaignBestSectionCarouselSettings(section) {
  return {
    autoplayEnabled: section.getAttribute("data-autoplay") !== "false",
    autoplayDelay:
      parseCampaignBestSettingNumber(
        section.getAttribute("data-autoplay-delay"),
        3,
      ) * 1000,
    autoplayPauseOnHover:
      section.getAttribute("data-autoplay-pause-on-hover") === "true",
    freeModeEnabled: section.getAttribute("data-enable-free-mode") !== "false",
    freeModeSticky: section.getAttribute("data-free-mode-sticky") !== "false",
    loopEnabled: section.getAttribute("data-enable-loop") !== "false",
    desktopDragEnabled:
      section.getAttribute("data-enable-desktop-drag") !== "false",
    transitionSpeed: parseCampaignBestSettingNumber(
      section.getAttribute("data-transition-speed"),
      500,
    ),
    swipeThreshold: parseCampaignBestSettingNumber(
      section.getAttribute("data-swipe-threshold"),
      12,
    ),
    desktopDragThreshold: parseCampaignBestSettingNumber(
      section.getAttribute("data-desktop-drag-threshold"),
      5,
    ),
    grabCursorEnabled:
      section.getAttribute("data-enable-grab-cursor") !== "false",
    freeModeMomentumRatio: parseCampaignBestSettingNumber(
      section.getAttribute("data-free-mode-momentum-ratio"),
      0.85,
    ),
    freeModeMomentumBounce:
      section.getAttribute("data-free-mode-momentum-bounce") !== "false",
    pagination: {
      show: section.getAttribute("data-show-pagination") !== "false",
      type: section.getAttribute("data-pagination-type") || "bullets",
      clickable: section.getAttribute("data-pagination-clickable") !== "false",
      dynamic: section.getAttribute("data-pagination-dynamic") === "true",
    },
  };
}

function pauseCampaignBestAutoplay(swiper) {
  if (!swiper || !swiper.autoplay) return;
  if (typeof swiper.autoplay.pause === "function") {
    swiper.autoplay.pause();
    return;
  }
  swiper.autoplay.stop();
}

function resumeCampaignBestAutoplay(swiper, panel, controls) {
  if (!swiper || !swiper.autoplay || !panel.classList.contains("is-active"))
    return;
  if (typeof swiper.autoplay.resume === "function") {
    swiper.autoplay.resume();
    return;
  }
  if (controls && typeof controls.resume === "function") {
    controls.resume();
  }
}

function bindCampaignBestAutoplayInteraction(swiper, panel, controls) {
  if (!controls.autoplayEnabled || !swiper.autoplay) return;

  var pausedByUser = false;

  function markPausedByUser() {
    pausedByUser = true;
    pauseCampaignBestAutoplay(swiper);
  }

  function tryResumeAfterUserInteraction() {
    if (!pausedByUser) return;
    pausedByUser = false;
    resumeCampaignBestAutoplay(swiper, panel, controls);
  }

  swiper.on("sliderFirstMove", markPausedByUser);
  swiper.on("touchEnd", function () {
    if (!panel.classList.contains("is-active")) {
      pausedByUser = false;
      return;
    }
    tryResumeAfterUserInteraction();
  });
  swiper.on("slideChangeTransitionEnd", function () {
    if (!pausedByUser || !panel.classList.contains("is-active")) return;
    tryResumeAfterUserInteraction();
  });
}

function getCampaignBestActiveBrandTabLabel() {
  var activeBrandTab = document.querySelector(
    "[data-members-week-brand-tab].is-active",
  );
  if (!activeBrandTab) return "";
  return (
    activeBrandTab.getAttribute("data-members-week-button-label") ||
    activeBrandTab.textContent
  );
}

function isCampaignBestTouchDevice() {
  return (
    "ontouchstart" in window ||
    (navigator.maxTouchPoints && navigator.maxTouchPoints > 0)
  );
}

function getCampaignBestMinSlidesForLoop(options) {
  var slidesPerView = options.slidesPerView;
  var slidesPerGroup = options.slidesPerGroup || 1;
  var loopAdditionalSlides = options.loopAdditionalSlides || 0;
  var centeredSlides = options.centeredSlides === true;
  var loopSlidesPerView = Math.ceil(slidesPerView);

  if (centeredSlides && loopSlidesPerView % 2 === 0) {
    loopSlidesPerView += 1;
  }

  var loopedGroup = centeredSlides
    ? Math.max(slidesPerGroup, Math.ceil(loopSlidesPerView / 2))
    : slidesPerGroup;

  if (loopedGroup % slidesPerGroup !== 0) {
    loopedGroup += slidesPerGroup - (loopedGroup % slidesPerGroup);
  }

  loopedGroup += loopAdditionalSlides;

  return loopSlidesPerView + loopedGroup;
}

function resolveCampaignBestSwiperModes(options) {
  var slideCount = options.slideCount;
  var slidesPerViewMax = options.slidesPerViewMax;
  var loopEnabled = options.loopEnabled;
  var desktopDragEnabled = options.desktopDragEnabled;
  var autoplayEnabled = options.autoplayEnabled;
  var freeModeEnabled = options.freeModeEnabled !== false;
  var isTouchDevice = options.isTouchDevice;
  var isFinePointer = options.isFinePointer;
  var minSlidesForLoop = getCampaignBestMinSlidesForLoop({
    slidesPerView: slidesPerViewMax,
    slidesPerGroup: options.slidesPerGroup || 1,
    loopAdditionalSlides: options.loopAdditionalSlides || 0,
    centeredSlides: options.centeredSlides === true,
  });
  var hasOverflowSlides = slideCount > slidesPerViewMax;
  var useLoop =
    loopEnabled && hasOverflowSlides && slideCount >= minSlidesForLoop;
  var useRewind = !useLoop && autoplayEnabled && hasOverflowSlides;
  var useCustomDesktopDrag =
    desktopDragEnabled && isFinePointer && !isTouchDevice && !useLoop;
  var enableSwiperTouch =
    isTouchDevice || (desktopDragEnabled && !useCustomDesktopDrag);
  var useFreeMode = freeModeEnabled && !useLoop && !useRewind;

  return {
    useLoop: useLoop,
    useRewind: useRewind,
    useCustomDesktopDrag: useCustomDesktopDrag,
    enableSwiperTouch: enableSwiperTouch,
    useFreeMode: useFreeMode,
  };
}

function parseCampaignBestSettingNumber(value, fallback) {
  var parsed = parseFloat(value);
  return Number.isFinite(parsed) ? parsed : fallback;
}

function buildCampaignBestFreeModeConfig(options) {
  if (!options.useFreeMode) {
    return { enabled: false };
  }

  var momentumRatio = parseCampaignBestSettingNumber(
    options.momentumRatio,
    0.85,
  );

  return {
    enabled: true,
    sticky: options.sticky !== false,
    momentum: true,
    momentumRatio: momentumRatio,
    momentumVelocityRatio: momentumRatio,
    momentumBounce: options.momentumBounce !== false,
  };
}

function buildCampaignBestAutoplayConfig(options) {
  return {
    delay: options.delay,
    disableOnInteraction: false,
    pauseOnMouseEnter: options.pauseOnHover !== false,
    waitForTransition: true,
    stopOnLastSlide: false,
  };
}

function buildCampaignBestSwiperInteractionConfig(options) {
  var swipeThreshold = parseCampaignBestSettingNumber(
    options.swipeThreshold,
    12,
  );
  var transitionSpeed = parseCampaignBestSettingNumber(
    options.transitionSpeed,
    500,
  );

  return {
    speed: transitionSpeed,
    threshold: options.enableSwiperTouch
      ? swipeThreshold
      : Math.max(swipeThreshold - 2, 5),
    grabCursor:
      options.grabCursorEnabled !== false && options.enableSwiperTouch,
    desktopDragThreshold: parseCampaignBestSettingNumber(
      options.desktopDragThreshold,
      5,
    ),
  };
}

function readCampaignBestSectionCarouselSettings(section) {
  return {
    autoplayEnabled: section.getAttribute("data-autoplay") !== "false",
    autoplayDelay:
      parseCampaignBestSettingNumber(
        section.getAttribute("data-autoplay-delay"),
        3,
      ) * 1000,
    autoplayPauseOnHover:
      section.getAttribute("data-autoplay-pause-on-hover") === "true",
    freeModeEnabled: section.getAttribute("data-enable-free-mode") !== "false",
    freeModeSticky: section.getAttribute("data-free-mode-sticky") !== "false",
    loopEnabled: section.getAttribute("data-enable-loop") !== "false",
    desktopDragEnabled:
      section.getAttribute("data-enable-desktop-drag") !== "false",
    transitionSpeed: parseCampaignBestSettingNumber(
      section.getAttribute("data-transition-speed"),
      500,
    ),
    swipeThreshold: parseCampaignBestSettingNumber(
      section.getAttribute("data-swipe-threshold"),
      12,
    ),
    desktopDragThreshold: parseCampaignBestSettingNumber(
      section.getAttribute("data-desktop-drag-threshold"),
      5,
    ),
    grabCursorEnabled:
      section.getAttribute("data-enable-grab-cursor") !== "false",
    freeModeMomentumRatio: parseCampaignBestSettingNumber(
      section.getAttribute("data-free-mode-momentum-ratio"),
      0.85,
    ),
    freeModeMomentumBounce:
      section.getAttribute("data-free-mode-momentum-bounce") !== "false",
    pagination: {
      show: section.getAttribute("data-show-pagination") !== "false",
      type: section.getAttribute("data-pagination-type") || "bullets",
      clickable: section.getAttribute("data-pagination-clickable") !== "false",
      dynamic: section.getAttribute("data-pagination-dynamic") === "true",
    },
  };
}

function pauseCampaignBestAutoplay(swiper) {
  if (!swiper || !swiper.autoplay) return;
  if (typeof swiper.autoplay.pause === "function") {
    swiper.autoplay.pause();
    return;
  }
  swiper.autoplay.stop();
}

function resumeCampaignBestAutoplay(swiper, panel, controls) {
  if (!swiper || !swiper.autoplay || !panel.classList.contains("is-active"))
    return;
  if (typeof swiper.autoplay.resume === "function") {
    swiper.autoplay.resume();
    return;
  }
  if (controls && typeof controls.resume === "function") {
    controls.resume();
  }
}

function bindCampaignBestAutoplayInteraction(swiper, panel, controls) {
  if (!controls.autoplayEnabled || !swiper.autoplay) return;

  var pausedByUser = false;

  function markPausedByUser() {
    pausedByUser = true;
    pauseCampaignBestAutoplay(swiper);
  }

  function tryResumeAfterUserInteraction() {
    if (!pausedByUser) return;
    pausedByUser = false;
    resumeCampaignBestAutoplay(swiper, panel, controls);
  }

  swiper.on("sliderFirstMove", markPausedByUser);
  swiper.on("touchEnd", function () {
    if (!panel.classList.contains("is-active")) {
      pausedByUser = false;
      return;
    }
    tryResumeAfterUserInteraction();
  });
  swiper.on("slideChangeTransitionEnd", function () {
    if (!pausedByUser || !panel.classList.contains("is-active")) return;
    tryResumeAfterUserInteraction();
  });
}

function getCampaignBestActiveBrandTabLabel() {
  var activeBrandTab = document.querySelector(
    "[data-members-week-brand-tab].is-active",
  );
  if (!activeBrandTab) return "";
  return (
    activeBrandTab.getAttribute("data-members-week-button-label") ||
    activeBrandTab.textContent
  );
}

function getCampaignBestActiveNavigationLabel() {
  var activeItem = document.querySelector("[data-members-week-item].is-active");
  var activeBrandTab = document.querySelector(
    "[data-members-week-brand-tab].is-active",
  );

  if (activeItem) {
    var desktopLabel = activeItem.querySelector(
      ".members-week-navigation__label--desktop",
    );
    var mobileLabel = activeItem.querySelector(
      ".members-week-navigation__label--mobile",
    );
    return (desktopLabel || mobileLabel || activeItem).textContent;
  }

  return activeBrandTab ? activeBrandTab.textContent : "";
}

function campaignBestEscapeHTML(value) {
  return String(value == null ? "" : value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

function campaignBestFormatMoney(price) {
  if (price == null || isNaN(price)) return "0원";
  return Math.round(price).toLocaleString("ko-KR") + "원";
}

function campaignBestAppendWidth(url, width) {
  if (!url) return "";
  var escaped = campaignBestEscapeHTML(url);
  var separator = escaped.indexOf("?") >= 0 ? "&" : "?";
  return escaped + separator + "width=" + width;
}

function campaignBestGenerateSrcset(imageUrl) {
  if (!imageUrl) return "";
  var widths = [320, 480, 640, 800, 900];
  var parts = [];
  for (var i = 0; i < widths.length; i++) {
    parts.push(
      campaignBestAppendWidth(imageUrl, widths[i]) + " " + widths[i] + "w",
    );
  }
  return parts.join(", ");
}

function campaignBestPickImage(product) {
  var pools = [
    product.commonPlpImages,
    product.womenPlpImages,
    product.menPlpImages,
    product.plpImages,
    product.images,
  ];
  for (var i = 0; i < pools.length; i++) {
    var pool = pools[i];
    if (Array.isArray(pool) && pool.length) {
      var first = pool[0];
      if (typeof first === "string") return first;
      if (first && first.url) return first.url;
      if (first && first.src) return first.src;
    }
  }
  if (product.featuredImage) {
    if (typeof product.featuredImage === "string") return product.featuredImage;
    if (product.featuredImage.url) return product.featuredImage.url;
  }
  if (product.featured_image) return product.featured_image;
  if (product.image) return product.image;
  return "";
}

function campaignBestBuildSlideHTML(product, index, opts) {
  var url = product.url || "/products/" + (product.handle || "");
  var title = product.title || "";
  var titleEscaped = campaignBestEscapeHTML(title);
  var price = Number(product.price) || 0;
  var compareAt =
    product.compareAtPrice != null ? Number(product.compareAtPrice) : null;
  var isSale = compareAt != null && compareAt > price;
  var discount = isSale
    ? Math.round(((compareAt - price) / compareAt) * 100)
    : 0;
  var imgSrc = campaignBestPickImage(product);
  var omsCd =
    product.oms_cd ||
    product.omsCd ||
    (product.metafields &&
      product.metafields.custom &&
      product.metafields.custom.oms_cd) ||
    product.handle ||
    "";
  var brand = product.brand || product.vendor || "";
  var productId = product.id || "";

  var rankClass = "campaign-bestproducts__rank";
  if (!opts.showRankDesktop)
    rankClass += " campaign-bestproducts__rank--hide-desktop";
  if (!opts.showRankMobile)
    rankClass += " campaign-bestproducts__rank--hide-mobile";
  var rankHTML =
    opts.showRankDesktop || opts.showRankMobile
      ? '<span class="' + rankClass + '">' + (index + 1) + "</span>"
      : "";

  var imgOnError =
    " onerror=\"this.onerror=null;this.outerHTML='<div class=&quot;campaign-bestproducts__placeholder&quot;></div>'\"";
  var imageHTML;
  if (!imgSrc) {
    imageHTML = '<div class="campaign-bestproducts__placeholder"></div>';
  } else if (imgSrc.indexOf(".gif") >= 0) {
    imageHTML =
      '<img class="campaign-bestproducts__image" src="' +
      campaignBestEscapeHTML(imgSrc) +
      '" alt="' +
      titleEscaped +
      '" loading="lazy"' +
      imgOnError +
      ">";
  } else {
    imageHTML =
      '<img class="campaign-bestproducts__image"' +
      ' srcset="' +
      campaignBestGenerateSrcset(imgSrc) +
      '"' +
      ' src="' +
      campaignBestAppendWidth(imgSrc, 900) +
      '"' +
      ' sizes="(max-width: 749px) 42vw, 21vw"' +
      ' alt="' +
      titleEscaped +
      '" loading="lazy"' +
      imgOnError +
      ">";
  }

  var priceHTML =
    '<div class="price-display campaign-bestproducts__price-display" data-price="' +
    price +
    '">' +
    '<div class="price-display__original"' +
    (isSale ? "" : ' style="display:none"') +
    ">" +
    '<span class="price-display__original-price">' +
    campaignBestFormatMoney(compareAt) +
    "</span>" +
    "</div>" +
    '<div class="price-display__current">' +
    '<span class="price-display__current-price">' +
    campaignBestFormatMoney(price) +
    "</span>" +
    "</div>" +
    '<div class="price-display__discount"' +
    (isSale ? "" : ' style="display:none"') +
    ">" +
    '<span class="price-display__discount-percentage">' +
    discount +
    "%</span>" +
    "</div>" +
    "</div>";

  return (
    "" +
    '<div class="swiper-slide campaign-bestproducts__slide">' +
    '<article class="campaign-bestproducts__card"' +
    " data-dl-product-card" +
    ' data-dl-item-id="' +
    campaignBestEscapeHTML(omsCd) +
    '"' +
    ' data-dl-item-name="' +
    titleEscaped +
    '"' +
    ' data-dl-item-price="' +
    price +
    '"' +
    ' data-dl-item-brand="' +
    campaignBestEscapeHTML(brand) +
    '"' +
    ' data-dl-shopify-id="' +
    campaignBestEscapeHTML(productId) +
    '">' +
    '<a href="' +
    campaignBestEscapeHTML(url) +
    '" class="campaign-bestproducts__media" aria-label="' +
    titleEscaped +
    '">' +
    rankHTML +
    imageHTML +
    "</a>" +
    '<div class="campaign-bestproducts__info">' +
    '<h3 class="campaign-bestproducts__title">' +
    '<a href="' +
    campaignBestEscapeHTML(url) +
    '">' +
    titleEscaped +
    "</a>" +
    "</h3>" +
    '<div class="campaign-bestproducts__price">' +
    priceHTML +
    "</div>" +
    "</div>" +
    "</article>" +
    "</div>"
  );
}

function campaignBestApiBaseUrl() {
  if (typeof FILA_API_BASE_URL !== "undefined" && FILA_API_BASE_URL) {
    return FILA_API_BASE_URL;
  }
  return "https://lkk-store-api.fila.co.kr";
}

function campaignBestGetAuthToken() {
  if (typeof window.FILA_AUTH_TOKEN === "string" && window.FILA_AUTH_TOKEN) {
    return window.FILA_AUTH_TOKEN;
  }
  try {
    var stored = localStorage.getItem("accessToken");
    if (stored) return stored;
  } catch (error) {}
  var match = document.cookie.match(/(?:^|;\s*)fila_auth_token=([^;]*)/);
  return match ? decodeURIComponent(match[1]) : null;
}

function campaignBestFetchProducts(collectionId, sortBy, pageSize) {
  var params = new URLSearchParams({
    collectionId: collectionId,
    sortBy: sortBy || "sale",
    page: "1",
    pageSize: String(pageSize || 36),
  });
  var url = campaignBestApiBaseUrl() + "/api/v2/products?" + params.toString();

  var controller = new AbortController();
  var timeoutId = setTimeout(function () {
    controller.abort();
  }, 30000);

  var options = { signal: controller.signal };
  var token = campaignBestGetAuthToken();
  if (token) {
    options.headers = { Authorization: "Bearer " + token };
  }

  return fetch(url, options)
    .then(function (response) {
      clearTimeout(timeoutId);
      if (!response.ok) throw new Error("API error: " + response.status);
      return response.json();
    })
    .then(function (data) {
      if (data && data.success === false) {
        throw new Error(data.error || "API request failed");
      }
      return (data && data.products) || [];
    });
}

function initCampaignBestProducts(root) {
  var scope = root || document;

  scope
    .querySelectorAll("[data-campaign-best-products]")
    .forEach(function (section) {
      if (section.dataset.bestProductsReady === "true") return;
      section.dataset.bestProductsReady = "true";

      var tabs = Array.prototype.slice.call(
        section.querySelectorAll("[data-best-tab]"),
      );
      var panels = Array.prototype.slice.call(
        section.querySelectorAll("[data-best-panel]"),
      );
      var swipers = {};
      var carouselSettings = readCampaignBestSectionCarouselSettings(section);
      var autoplayEnabled = carouselSettings.autoplayEnabled;
      var autoplayDelay = carouselSettings.autoplayDelay;
      var autoplayPauseOnHover = carouselSettings.autoplayPauseOnHover;
      var freeModeEnabled = carouselSettings.freeModeEnabled;
      var freeModeSticky = carouselSettings.freeModeSticky;
      var transitionSpeed = carouselSettings.transitionSpeed;
      var swipeThreshold = carouselSettings.swipeThreshold;
      var desktopDragThreshold = carouselSettings.desktopDragThreshold;
      var grabCursorEnabled = carouselSettings.grabCursorEnabled;
      var freeModeMomentumRatio = carouselSettings.freeModeMomentumRatio;
      var freeModeMomentumBounce = carouselSettings.freeModeMomentumBounce;
      var showRankDesktop =
        section.getAttribute("data-show-rank-desktop") !== "false";
      var showRankMobile =
        section.getAttribute("data-show-rank-mobile") !== "false";

      function getTabSortOrder(element) {
        var value = Number(element.getAttribute("data-best-tab-order"));
        return Number.isFinite(value) ? value : 10;
      }

      function sortElementsByTabOrder(elements) {
        return elements
          .map(function (element, index) {
            return {
              element: element,
              index: index,
              order: getTabSortOrder(element),
            };
          })
          .sort(function (a, b) {
            if (a.order !== b.order) return a.order - b.order;
            return a.index - b.index;
          })
          .map(function (item) {
            return item.element;
          });
      }

      function applyTabOrder() {
        var tabsContainer = section.querySelector("[data-best-tabs]");
        var panelsContainer = section.querySelector("[data-best-panels]");
        if (!tabsContainer || !panelsContainer) return;

        tabs = sortElementsByTabOrder(tabs);
        panels = sortElementsByTabOrder(panels);

        tabs.forEach(function (tab) {
          tabsContainer.appendChild(tab);
        });

        panels.forEach(function (panel) {
          panelsContainer.appendChild(panel);
        });
      }

      applyTabOrder();

      function getTargetLabel(element) {
        return normalizeCampaignBestLabel(
          element.getAttribute("data-best-target-label"),
        );
      }

      function getTabsForLabel(label) {
        var normalizedLabel = normalizeCampaignBestLabel(label);
        var exactTabs = tabs.filter(function (tab) {
          return getTargetLabel(tab) && getTargetLabel(tab) === normalizedLabel;
        });

        if (exactTabs.length) return exactTabs;

        var defaultTabs = tabs.filter(function (tab) {
          return !getTargetLabel(tab);
        });

        return defaultTabs.length ? defaultTabs : tabs;
      }

      function getTabBrand(tab) {
        return tab.getAttribute("data-best-brand") || "primary";
      }

      function hasBrandData() {
        var brands = tabs.map(getTabBrand);
        var unique = brands.filter(function (brand, index, list) {
          return list.indexOf(brand) === index;
        });
        return (
          unique.length > 1 ||
          unique.indexOf("secondary") !== -1 ||
          unique.indexOf("both") !== -1
        );
      }

      function filterTabsByBrand(brand) {
        var validBrands = [brand, "both"];
        return tabs.filter(function (tab) {
          return validBrands.indexOf(getTabBrand(tab)) !== -1;
        });
      }

      function filterTabsByTabLabel(tabLabel) {
        if (!tabLabel) return [];
        var normalized = normalizeCampaignBestLabel(tabLabel);
        return tabs.filter(function (tab) {
          return getTargetLabel(tab) === normalized;
        });
      }

      function applyVisibleTabs(visibleTabs) {
        var visibleIds = visibleTabs.map(function (tab) {
          return tab.getAttribute("data-tab-target");
        });
        var activeVisibleTab =
          visibleTabs.filter(function (tab) {
            return tab.classList.contains("is-active");
          })[0] || visibleTabs[0];

        tabs.forEach(function (tab) {
          tab.hidden =
            visibleIds.indexOf(tab.getAttribute("data-tab-target")) === -1;
        });

        panels.forEach(function (panel) {
          panel.hidden =
            visibleIds.indexOf(panel.getAttribute("data-panel-id")) === -1;
        });

        if (activeVisibleTab) {
          activatePanel(activeVisibleTab.getAttribute("data-tab-target"));
        }
      }

      function setGroupByBrand(brand, tabLabel) {
        var visibleTabs = filterTabsByBrand(brand);

        if (!visibleTabs.length) {
          visibleTabs = filterTabsByTabLabel(
            tabLabel || getCampaignBestActiveBrandTabLabel(),
          );
        }

        if (!visibleTabs.length) visibleTabs = tabs;

        applyVisibleTabs(visibleTabs);
      }

      function setGroupByLabel(label) {
        var visibleTabs = getTabsForLabel(label);
        applyVisibleTabs(visibleTabs);
      }

      function activateFirstAvailableTab() {
        var visibleTabs = tabs.filter(function (tab) {
          return !tab.hidden;
        });

        for (var i = 0; i < visibleTabs.length; i++) {
          var tab = visibleTabs[i];
          var panel = panels.filter(function (candidate) {
            return (
              candidate.getAttribute("data-panel-id") ===
              tab.getAttribute("data-tab-target")
            );
          })[0];
          if (!panel) continue;

          materializePanel(panel);
          if (panel.querySelectorAll(".swiper-slide").length > 0) {
            activatePanel(tab.getAttribute("data-tab-target"));
            return true;
          }
        }

        if (visibleTabs[0]) {
          activatePanel(visibleTabs[0].getAttribute("data-tab-target"));
        }

        return false;
      }

      function ensureActivePanelHasSlides() {
        var activePanel = section.querySelector("[data-best-panel].is-active");
        if (!activePanel || activePanel.hidden) {
          activateFirstAvailableTab();
          return;
        }

        materializePanel(activePanel);
        if (activePanel.querySelectorAll(".swiper-slide").length > 0) {
          initSwiper(activePanel);
          setTimeout(function () {
            refreshSwiperPanel(activePanel);
          }, 120);
          return;
        }

        activateFirstAvailableTab();
      }

      function materializePanel(panel) {
        var template = panel.querySelector("template[data-best-lazy-content]");
        if (!template) return false;
        panel.appendChild(template.content);
        template.remove();
        return true;
      }

      function maybeLoadPanelFromApi(panel, swiperEl) {
        var collectionId = swiperEl.getAttribute("data-best-collection-id");
        if (!collectionId) return;

        var apiState = swiperEl.dataset.bestApiState;
        if (apiState === "loading" || apiState === "done") return;
        swiperEl.dataset.bestApiState = "loading";

        var wrapper =
          swiperEl.querySelector("[data-best-wrapper]") ||
          swiperEl.querySelector(".swiper-wrapper");
        if (!wrapper) {
          swiperEl.dataset.bestApiState = "error";
          return;
        }

        var pageSize = parseInt(swiperEl.dataset.bestPageSize, 10) || 36;
        var sortBy = swiperEl.getAttribute("data-best-sort-by") || "sale";

        swiperEl.classList.add("is-loading");

        campaignBestFetchProducts(collectionId, sortBy, pageSize)
          .then(function (products) {
            swiperEl.classList.remove("is-loading");
            swiperEl.dataset.bestApiState = "done";

            if (!products || !products.length) return;

            var limit = Math.min(products.length, pageSize);
            var html = "";
            for (var i = 0; i < limit; i++) {
              html += campaignBestBuildSlideHTML(products[i], i, {
                showRankDesktop: showRankDesktop,
                showRankMobile: showRankMobile,
              });
            }
            wrapper.innerHTML = html;

            initSwiper(panel);
            setTimeout(function () {
              refreshSwiperPanel(panel);
            }, 120);
          })
          .catch(function (error) {
            swiperEl.classList.remove("is-loading");
            swiperEl.dataset.bestApiState = "error";
            console.error("CampaignBestProducts API error", error);
          });
      }

      function stampSlideRanks(swiperEl) {
        var slides = swiperEl.querySelectorAll(".swiper-slide");
        Array.prototype.forEach.call(slides, function (slide, index) {
          if (!slide.getAttribute("data-best-rank")) {
            slide.setAttribute("data-best-rank", String(index + 1));
          }
        });
      }

      function startPanelAutoplay(panel) {
        var panelId = panel.getAttribute("data-panel-id");
        var swiper = swipers[panelId];
        if (
          !autoplayEnabled ||
          !swiper ||
          !swiper.autoplay ||
          !panel.classList.contains("is-active")
        )
          return;
        swiper.autoplay.stop();
        swiper.autoplay.start();
      }

      function stopPanelAutoplay(panelId) {
        var swiper = swipers[panelId];
        if (swiper && swiper.autoplay) {
          swiper.autoplay.stop();
        }
      }

      function refreshSwiperPanel(panel) {
        var panelId = panel.getAttribute("data-panel-id");
        var swiper = swipers[panelId];
        if (!swiper) return;

        swiper.update();
        updateSlideRanks(swiper);

        if (panel.classList.contains("is-active") && autoplayEnabled) {
          startPanelAutoplay(panel);
        } else {
          stopPanelAutoplay(panelId);
        }
      }

      function getSlideRankValue(swiper, slideEl) {
        if (!slideEl) return 0;

        var storedRank = parseInt(slideEl.getAttribute("data-best-rank"), 10);
        if (storedRank) return storedRank;

        if (
          swiper &&
          swiper.params &&
          swiper.params.loop &&
          typeof swiper.getSlideIndex === "function"
        ) {
          var loopIndex = swiper.getSlideIndex(slideEl);
          if (Number.isFinite(loopIndex) && loopIndex >= 0)
            return loopIndex + 1;
        }

        var swiperIndex = parseInt(
          slideEl.getAttribute("data-swiper-slide-index"),
          10,
        );
        if (Number.isFinite(swiperIndex) && swiperIndex >= 0)
          return swiperIndex + 1;

        return 0;
      }

      function updateSlideRanks(swiper) {
        if (!swiper) return;

        Array.prototype.forEach.call(swiper.slides || [], function (slideEl) {
          var rankEl = slideEl.querySelector(".campaign-bestproducts__rank");
          if (!rankEl) return;

          var rank = getSlideRankValue(swiper, slideEl);
          if (rank > 0) rankEl.textContent = String(rank);
        });
      }

      function attachRankSync(swiper) {
        updateSlideRanks(swiper);
        swiper.on("slideChange", function () {
          updateSlideRanks(swiper);
        });
        swiper.on("transitionEnd", function () {
          updateSlideRanks(swiper);
        });
        swiper.on("resize", function () {
          updateSlideRanks(swiper);
        });
      }

      function initSwiper(panel) {
        var panelId = panel.getAttribute("data-panel-id");
        var swiperEl = panel.querySelector("[data-best-swiper]");
        if (!swiperEl) return;

        if (swipers[panelId]) {
          refreshSwiperPanel(panel);
          return;
        }

        if (swiperEl.swiper && typeof swiperEl.swiper.destroy === "function") {
          try {
            swiperEl.swiper.destroy(true, true);
          } catch (error) {}
        }

        var slidesMobile = parseFloat(swiperEl.dataset.slidesMobile) || 2.5;
        var slidesDesktop = parseFloat(swiperEl.dataset.slidesDesktop) || 4.5;
        var slideGap = parseInt(swiperEl.dataset.slideGap, 10) || 14;
        var slidesPerViewMax = Math.max(slidesMobile, slidesDesktop);
        var slideCount = swiperEl.querySelectorAll(".swiper-slide").length;
        if (slideCount === 0) {
          maybeLoadPanelFromApi(panel, swiperEl);
          return;
        }

        var loopEnabled = carouselSettings.loopEnabled;
        var swiperModes = resolveCampaignBestSwiperModes({
          slideCount: slideCount,
          slidesPerViewMax: slidesPerViewMax,
          loopEnabled: loopEnabled,
          desktopDragEnabled: false,
          autoplayEnabled: autoplayEnabled,
          freeModeEnabled: false,
          isTouchDevice: isCampaignBestTouchDevice(),
          isFinePointer: window.matchMedia("(pointer: fine)").matches,
        });
        var useLoop = swiperModes.useLoop;
        var useRewind = swiperModes.useRewind;
        // 드래그(스냅) 활성화: 데스크톱 마우스/모바일 터치 모두 드래그하면 다른 상품으로 이동
        var enableSwiperTouch = true;
        var interactionConfig = buildCampaignBestSwiperInteractionConfig({
          transitionSpeed: transitionSpeed,
          swipeThreshold: swipeThreshold,
          grabCursorEnabled: true,
          enableSwiperTouch: enableSwiperTouch,
        });

        swiperEl.style.setProperty("--slide-gap", slideGap + "px");
        stampSlideRanks(swiperEl);

        var paginationEl = swiperEl.querySelector("[data-best-pagination]");
        var paginationSettings = carouselSettings.pagination;

        var swiperConfig = {
          slidesPerView: slidesMobile,
          spaceBetween: slideGap,
          watchOverflow: !useLoop && !useRewind,
          watchSlidesProgress: true,
          threshold: interactionConfig.threshold,
          speed: interactionConfig.speed,
          allowTouchMove: enableSwiperTouch,
          simulateTouch: enableSwiperTouch,
          grabCursor: interactionConfig.grabCursor,
          preventClicks: true,
          preventClicksPropagation: true,
          touchStartPreventDefault: false,
          passiveListeners: true,
          observer: true,
          observeParents: true,
          breakpoints: {
            750: {
              slidesPerView: slidesDesktop,
              spaceBetween: slideGap,
            },
          },
        };

        if (paginationSettings.show && paginationEl) {
          swiperConfig.pagination = {
            el: paginationEl,
            type: paginationSettings.type,
            clickable: paginationSettings.clickable,
            dynamicBullets:
              paginationSettings.type === "bullets" &&
              paginationSettings.dynamic,
          };
        }

        if (useLoop) {
          swiperConfig.loop = true;
          swiperConfig.centerInsufficientSlides = false;
        }

        if (useRewind) {
          swiperConfig.rewind = true;
        }

        if (autoplayEnabled) {
          swiperConfig.autoplay = buildCampaignBestAutoplayConfig({
            delay: autoplayDelay,
            pauseOnHover: autoplayPauseOnHover,
          });
        }

        swipers[panelId] = new Swiper(swiperEl, swiperConfig);
        attachRankSync(swipers[panelId]);

        bindCampaignBestAutoplayInteraction(swipers[panelId], panel, {
          autoplayEnabled: autoplayEnabled,
          pause: function () {
            stopPanelAutoplay(panelId);
          },
          resume: function () {
            if (panel.classList.contains("is-active")) {
              startPanelAutoplay(panel);
            }
          },
        });

        if (panel.classList.contains("is-active") && autoplayEnabled) {
          startPanelAutoplay(panel);
        }

        swiperEl.querySelectorAll("a").forEach(function (anchor) {
          anchor.draggable = false;
        });

        swiperEl.querySelectorAll("img").forEach(function (img) {
          img.draggable = false;
          if (img.complete) return;
          img.addEventListener("load", function () {
            var instance = swipers[panelId];
            if (!instance || !instance.update) return;
            instance.update();
            if (autoplayEnabled && panel.classList.contains("is-active")) {
              startPanelAutoplay(panel);
            }
          });
        });
      }

      function activatePanel(targetId) {
        tabs.forEach(function (tab) {
          tab.classList.toggle(
            "is-active",
            tab.getAttribute("data-tab-target") === targetId,
          );
        });

        panels.forEach(function (panel) {
          var isActive = panel.getAttribute("data-panel-id") === targetId;
          panel.classList.toggle("is-active", isActive);
          var panelId = panel.getAttribute("data-panel-id");
          if (swipers[panelId]) {
            if (isActive && autoplayEnabled) {
              startPanelAutoplay(panel);
            } else {
              stopPanelAutoplay(panelId);
            }
          }
          if (isActive) {
            materializePanel(panel);
            initSwiper(panel);
            setTimeout(function () {
              refreshSwiperPanel(panel);
            }, 120);
          }
        });
      }

      if (hasBrandData()) {
        var brandTab = document.querySelector(
          "[data-members-week-brand-tab].is-active",
        );
        var brand = brandTab
          ? brandTab.getAttribute("data-members-week-brand")
          : "primary";
        setGroupByBrand(brand, getCampaignBestActiveBrandTabLabel());
      } else {
        setGroupByLabel(getCampaignBestActiveNavigationLabel());
      }

      ensureActivePanelHasSlides();

      if (autoplayEnabled) {
        document.addEventListener("visibilitychange", function () {
          if (!document.contains(section)) return;

          var activePanel = section.querySelector(
            "[data-best-panel].is-active:not([hidden])",
          );
          if (!activePanel) return;

          if (document.hidden) {
            stopPanelAutoplay(activePanel.getAttribute("data-panel-id"));
            return;
          }

          startPanelAutoplay(activePanel);
        });
      }

      tabs.forEach(function (tab) {
        tab.addEventListener("click", function () {
          if (tab.hidden) return;
          activatePanel(tab.getAttribute("data-tab-target"));
        });
      });

      document.addEventListener(
        "members-week:navigation-change",
        function (event) {
          if (!document.contains(section)) return;
          var label =
            event.detail && (event.detail.label || event.detail.brandLabel);
          var brand = event.detail && event.detail.brand;
          if (hasBrandData() && brand) {
            setGroupByBrand(brand, getCampaignBestActiveBrandTabLabel());
            if (
              label &&
              normalizeCampaignBestLabel(label) !==
                normalizeCampaignBestLabel(getCampaignBestActiveBrandTabLabel())
            ) {
              setGroupByLabel(label);
            }
          } else {
            setGroupByLabel(label);
          }
        },
      );

      document.addEventListener(
        "members-week-navigation:change",
        function (event) {
          if (!document.contains(section)) return;
          var brand = event.detail && event.detail.brand;
          var label = event.detail && event.detail.label;
          if (hasBrandData() && brand) {
            setGroupByBrand(brand, label);
          } else if (label) {
            setGroupByLabel(label);
          }
        },
      );

      section.addEventListener("click", function (event) {
        if (typeof FilaDL === "undefined") return;
        var card = event.target.closest("[data-dl-product-card]");
        if (!card || section.querySelector(".is-dragging")) return;
        var activeTab = section.querySelector("[data-best-tab].is-active");

        FilaDL.push({
          event: "main_click",
          click: {
            type: "product",
            item_id: card.getAttribute("data-dl-item-id") || "",
            item_name: card.getAttribute("data-dl-item-name") || "",
            item_price:
              parseFloat(card.getAttribute("data-dl-item-price")) || 0,
            main_box_name:
              section.getAttribute("data-dl-section-name") || "Best",
            sub_box_name: activeTab ? activeTab.textContent.trim() : "",
            page_type: FilaDL.getMainPageType(),
          },
        });
      });
    });
}

document.addEventListener("DOMContentLoaded", function () {
  initCampaignBestProducts(document);
});

document.addEventListener("shopify:section:load", function (event) {
  initCampaignBestProducts(event.target);
});
